// Planned notes: the short instruction a plan attaches to one exercise, and
// the note of a cardio prescription. New and edited notes are limited to 70
// characters, here and by the API (which refuses a longer one). A longer note
// written before the limit is still shown whole; it has to be shortened before
// the workout it belongs to can be saved again.
export const PLANNED_EXERCISE_NOTE_MAX_LENGTH = 70;

export function isPlannedExerciseNoteTooLong(value) {
  return String(value || "").trim().length > PLANNED_EXERCISE_NOTE_MAX_LENGTH;
}

export const PLANNED_EXERCISE_NOTE_TOO_LONG_COPY =
  `Notes are limited to ${PLANNED_EXERCISE_NOTE_MAX_LENGTH} characters. Shorten this one to save your changes.`;
